import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { StatusEnum } from "types/core";

export const GET_ITEM_QUERY = print(gql`
  query Event($id: Int!) {
    AdminEventInternalContent(id: $id)
    AdminEventRelatedPosts(eventId: $id) {
      id
    }
    Event(id: $id) {
      id
      title
      titleContrast
      slug
      descriptionContentHTML
      programationJSON
      registration
      registrationLink
      localization
      address
      hourInit
      formId
      saleEnabled
      ticketPrice
      ticketLimit
      ticketSalesEndAt
      financialPriceSyncUntil
      eCommerceProductId
      eCommerceControlSKUId
      eCommerceSkuId
      moodleId
      educationalUnitId
      eventClassificationId
      createdAt
      updatedAt
      publishOn
      expiresIn
      dateInit
      dateFinish
      status
      mediaFileDesktop {
        id
        url
      }
      mediaFileMobile {
        id
      }
      modality
    }
  }
`);

export interface GetItemGql {
  AdminEventInternalContent?: string;
  AdminEventRelatedPosts: Array<{ id: number }>;
  Event: {
    formId: string;
    localization: string;
    address: string;
    createdAt: string;
    dateFinish: string;
    dateInit: string;
    descriptionContentHTML: string;
    expiresIn: string;
    hourInit: string;
    id: number;
    saleEnabled: boolean;
    ticketPrice?: number;
    ticketLimit?: number;
    ticketSalesEndAt?: string;
    financialPriceSyncUntil?: string;
    eCommerceProductId?: number;
    eCommerceControlSKUId?: number;
    eCommerceSkuId?: number;
    moodleId?: string;
    educationalUnitId?: number;
    eventClassificationId: number;
    imageUrl?: string;
    idMediaFileDesktop?: number;
    idMediaFileMobile?: number;
    relatedEventsIds?: number[];
    relatedPostsIds?: number[];
    mediaFileDesktop: {
      id: number;
      url?: string;
    };
    mediaFileMobile: {
      id: number;
    };
    modality: EventModalityEnum;
    programationJSON: string;
    internalContentJSON?: EventInternalContent;
    publishOn: string;
    registration: string;
    registrationLink: string;
    slug: string;
    status: StatusEnum;
    title: string;
    titleContrast: boolean;
    updatedAt: string;
  };
}

export type EventModalityEnum = "ONLINE" | "PRESENCIAL" | "HIBRIDA";

export type EventInternalContent = {
  version?: number;
  modules: Record<string, unknown>[];
  transmissions: Record<string, unknown>[];
  recordings: Record<string, unknown>[];
  materials: Record<string, unknown>[];
  announcements: Record<string, unknown>[];
  attendance?: Record<string, unknown>;
  certificate?: Record<string, unknown>;
  survey?: Record<string, unknown>;
};
